import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector, } from "react-redux";
import { Box, Layer, Main, Page, PageContent, PageHeader, Grid, ResponsiveContext } from "grommet";
import { Hpe, } from "grommet-icons";
import { AdminDashboardCard } from "../components/admin/AdminDashboardCard";
import { AddResourceContent } from "../components/admin/AddResourcesContent";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";


export const StorageAdminDashboard = () => {
    const size = useContext(ResponsiveContext);
    const { id } = useParams();
    const session = useSelector((state) => {
        return state.session;
    });
    const [isLayer, SetIsLayer] = useState(false);
    const competitorList = useSelector((state) => {
        return state.competitiveDash.competitors
    });
    const history = useHistory();
    useEffect(() => {
        if (Array.isArray(competitorList).length > 0) {

        }
    }, [competitorList])
    return (
        <Page>
            <PageContent>
                <PageHeader title={"Admin Console"} actions={[<Box direction="row" gap="medium" alignSelf="end" >
                    {/* <Button primary label="Add Document" onClick={() => { SetIsLayer(true) }} /> */}
                    {/* <Button secondary label="Add Announcement" /> */}
                </Box>]} />
                <Main align='center' gap="xlarge">
                    <Grid
                        columns={size === 'xlarge' || size === 'large' ? "25%" : '50%'} gap={"medium"}
                        rows={[["auto", "60%"]]}
                        pad='small'
                        fill
                    >
                        {data &&
                            data.map((datum, index) => <AdminDashboardCard key={index} card={datum} onClick={() => { history.push('/storage-admin-manager/' + id) }} />)}
                    </Grid>
                    <Box></Box>
                    {isLayer ? <>
                        <Layer position="center" onEsc={() => { SetIsLayer(false) }}>
                            <AddResourceContent session={session} onCloseHandler={() => { SetIsLayer(false) }} competitorOptions={competitorList.data} />
                        </Layer>
                    </> : <></>}
                </Main>
            </PageContent>
        </Page>
    );
};

export default StorageAdminDashboard;

export const data = [
    {
        cta: "Edit",
        title: 'Data Manager',
        description: `Configure and add data/resources to application portal`,
        descriptionColor: 'text-strong',
        icon: <Hpe color="plain" />,
    },
];